export { default } from "./useFormativeWebTokenGet";
